import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const TagStatusPin = (props) => {
  const { isLoading } = useSelector((state) => state.mySelf.callGetMySelf);
  const { isEnablePin } = props;
  const text = isEnablePin ? "Pin code enabled" : "Pin code disabled";
  return (
    <div className="tag-status-pin">
      {isLoading ? (
        <span className="tag-status-pin-loading">
          <CircularProgress size={20} color="inherit" className="spinner-icon" />
        </span>
      ) : isEnablePin ? (
        <span className="tag-status-pin-enabled">{text}</span>
      ) : (
        <span className="tag-status-pin-unabled">{text}</span>
      )}
    </div>
  );
};

export default TagStatusPin;
